import { setCombineSameSku } from "@/features/dataTableSlice";
import { getCurrentColumn } from "@/lib/getCurrentColumn";
import { ButtonSendTheme } from "@/styles/mui/tableListTheme";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import IosShareIcon from "@mui/icons-material/IosShare";
import SaveIcon from "@mui/icons-material/Save";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { ThemeProvider } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { useGridApiContext } from "@mui/x-data-grid";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  removeFilter,
  restoreFilter,
  saveFilter,
} from "@/features/dataTableSlice";
import _ from "lodash";
export function SaveFilterAndSearch(props) {
  const { fetchData, loading, page = "compareSales" } = props;
  const [openSave, setOpenSave] = React.useState(false);
  const anchorRef = React.useRef(null);

  const dispatch = useDispatch();
  const apiRef = useGridApiContext();
  const location = useLocation();
  const dateGrouping = useSelector((state) => state.dataTable.dateGrouping);
  const areaGrouping = useSelector((state) => state.dataTable.areaGrouping);
  const selectedBrand = useSelector((state) => state.dataTable.selectedBrand);
  const dateFilter = useSelector((state) => state.dataTable.dateFilter);
  const typeGrouping = useSelector((state) => state.dataTable.typeGrouping);
  const combineSameSku = useSelector((state) => state.dataTable.combineSameSku);
  const selectedSource = useSelector((state) => state.dataTable.selectedSource);
  const compareOption = useSelector((state) => state.dataTable.compareOption);

  const selectedProduct = useSelector(
    (state) => state.dataTable.selectedProduct
  );

  const savedFilter = useSelector(
    (state) => state.dataTable.savedFilter[location.pathname]
  );
  const handleMenuItemClick = async (event, index, type) => {
    if (type === "save") {
      const name = window.prompt("輸入篩選條件名稱");
      if (name) {
        const visableColumns = apiRef.current.getVisibleColumns();
        dispatch(
          saveFilter({ name, visableColumns, pathname: location.pathname })
        );
        const filter = {
          dateGrouping,
          selectedBrand,
          dateFilter,
          typeGrouping,
          selectedProduct,
          combineSameSku,
          visableColumns,
          areaGrouping,
          selectedSource,
          compareOption,
        };
        handleSearch(filter);
      }
    } else {
      const result = await dispatch(
        restoreFilter({ id: type, pathname: location.pathname })
      ).unwrap();
      handleSearch(result.selectedFilter);
    }
    setOpenSave(false);
  };
  const handleToggle = () => {
    setOpenSave((prevOpen) => !prevOpen);
  };
  const handleCloseSaveAction = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenSave(false);
  };
  const handleSearch = async (filter) => {
    const dateRanges = [
      [
        moment(filter.dateFilter.startDate1).format("YYYY-MM-DD"),
        moment(filter.dateFilter.endDate1).format("YYYY-MM-DD"),
      ],
      [
        filter.dateFilter.startDate2
          ? moment(filter.dateFilter.startDate2).format("YYYY-MM-DD")
          : null,
        filter.dateFilter.endDate2
          ? moment(filter.dateFilter.endDate2).format("YYYY-MM-DD")
          : null,
      ],
    ];
    await fetchData(
      filter.selectedBrand,
      filter.selectedProduct,
      dateRanges,
      filter.dateGrouping,
      filter.typeGrouping,
      filter.combineSameSku,
      filter.areaGrouping,
      filter.selectedSource,
      filter.compareOption
    );
    let visableColumns = [];
    let columnVisibilityModel = {};

    switch (page) {
      case "compareSales":
        visableColumns =
          filter?.visableColumns ?? apiRef.current.getVisibleColumns();
        const allColumns = getCurrentColumn(visableColumns, filter);
        const isCompare = Boolean(
          filter.dateFilter.startDate2 && filter.dateFilter.endDate2
        );
        //is default

        if (filter.visableColumns.length > 0) {
          columnVisibilityModel = {
            ...allColumns,
          };
        } else {
          columnVisibilityModel = {
            ...allColumns,
            product_name: false,
            brand_name: filter.typeGrouping === "brand",
            product_discount_price1:
              filter.dateGrouping === "day" && filter.typeGrouping !== "brand",
            product_discount_price2:
              filter.dateGrouping === "day" &&
              isCompare &&
              filter.typeGrouping === "product",
            m18_product_code: filter.typeGrouping !== "brand",
            tx_date1: filter.dateGrouping !== "selected_period",
            tx_date2: filter.dateGrouping !== "selected_period" && isCompare,
            qty1: true,
            amount1: true,
            qty2: isCompare,
            amount2: isCompare,
            variance_qty: isCompare,
            variance_amount: isCompare,
          };
        }
        apiRef.current.setColumnVisibilityModel(columnVisibilityModel);
        if (isCompare) {
          apiRef.current.setSortModel([
            { field: "variance_qty", sort: "desc" },
          ]);
        }
        break;
      case "profitAndLoss":
        // visableColumns = apiRef.current.getVisibleColumns();
        // _.forEach(visableColumns, (visableColumn) => {
        //   columnVisibilityModel[visableColumn.field] = true;
        // });
        // if (typeGrouping === "product") {
        //   columnVisibilityModel["brand_name"] = false;
        //   columnVisibilityModel["mannings_product_code"] = true;
        //   columnVisibilityModel["m18_product_code"] = true;
        //   columnVisibilityModel["product_name"] = true;
        // } else if (typeGrouping === "brand") {
        //   columnVisibilityModel["mannings_product_code"] = false;
        //   columnVisibilityModel["m18_product_code"] = false;
        //   columnVisibilityModel["product_name"] = false;
        //   columnVisibilityModel["brand_name"] = true;
        // }
        // apiRef.current.setColumnVisibilityModel(columnVisibilityModel);

        break;

      default:
        break;
    }
  };
  return (
    <FormControl sx={{ m: 2 }}>
      <ThemeProvider theme={ButtonSendTheme}>
        <ButtonGroup ref={anchorRef}>
          <FormControlLabel
            control={
              <Switch
                checked={combineSameSku}
                defaultChecked
                onChange={() => {
                  dispatch(setCombineSameSku());
                }}
              />
            }
            label="組合sku"
          />
          <LoadingButton
            disabled={
              !moment(dateFilter.startDate1).isValid() ||
              !moment(dateFilter.endDate1).isValid() ||
              selectedProduct.length <= 0
            }
            size="small"
            onClick={() => {
              const visableColumns = apiRef.current.getVisibleColumns();

              const filter = {
                dateGrouping,
                selectedBrand,
                dateFilter,
                typeGrouping,
                selectedProduct,
                combineSameSku,
                visableColumns,
                areaGrouping,
                selectedSource,
                compareOption,
              };
              handleSearch(filter);
            }}
            endIcon={<SearchOutlinedIcon fontSize="small" />}
            loadingPosition="end"
            variant="contained"
            loading={loading}
          >
            搜尋
          </LoadingButton>
          <Button
            size="small"
            variant="contained"
            // aria-controls={open ? 'split-button-menu' : undefined}
            // aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={openSave}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseSaveAction}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {_.map(savedFilter, (filter, index) => (
                      <MenuItem
                        key={`${filter.name}-${filter.id}`}
                        onClick={(event) => {
                          handleMenuItemClick(event, index, filter.id);
                        }}
                      >
                        {filter.name}
                        <DeleteForeverIcon
                          color="error"
                          onClick={(e) => {
                            const result = window.confirm(
                              `確定要刪除${filter.name}嗎？`
                            );
                            if (result) {
                              dispatch(
                                removeFilter({
                                  id: filter.id,
                                  pathname: location.pathname,
                                })
                              );
                            }
                            e.stopPropagation();
                          }}
                        />
                      </MenuItem>
                    ))}
                    <MenuItem
                      key="save"
                      onClick={(event) => {
                        navigator.clipboard.writeText(
                          `${window.location.href}?dateFilter=${JSON.stringify(
                            dateFilter
                          )}&dateGrouping=${dateGrouping}&typeGrouping=${typeGrouping}&areaGrouping=${areaGrouping}&selectedProduct=${selectedProduct}&selectedSource=${selectedSource}&compareOption=${compareOption}&combineSameSku=${combineSameSku}&isShare=ture`
                        );
                        window.alert("已複製連結");
                      }}
                    >
                      分享當前篩選條件
                      <IosShareIcon></IosShareIcon>
                    </MenuItem>
                    <MenuItem
                      key="save"
                      onClick={(event) => {
                        handleMenuItemClick(event, 0, "save");
                      }}
                    >
                      儲存篩選條件並搜尋
                      <SaveIcon></SaveIcon>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </ThemeProvider>
    </FormControl>
  );
}
